module.exports = __webpack_public_path__ + "img/how_to_complete_activity_1_trigger.2934296b.jpg";